import { LessonAttempt } from './LessonAttempt';
import { LessonCompletionType } from './LessonBehaviorSettings';
import LessonDisplaySettings from '../../content/models/LessonDisplaySettings';
import LessonResultVm from './LessonResultVm';
import ProgressStatusCode from './ProgressStatusCode';
import ZoneVm from './ZoneVm';

export const lessonTypeLabel: { [key in LessonType]: string } = {
  lesson: 'Lesson',
  quiz: 'Automarked Quiz',
  assessment: 'Formal Assessment',
  xapi: 'Lesson',
  unknown: '',
  critique: '',
  rubric: ''
};

export type LessonType =
  | 'unknown'
  | 'xapi'
  | 'lesson'
  | 'quiz'
  | 'assessment'
  | 'critique'
  | 'rubric';

export interface CourseLessonVm {
  pathkey: number;
  cert: boolean;
  lessonkey: number;
  lessonVersion: number;
  type: LessonType;
  title: string;
  description: string;
  required: boolean;
  completionType: LessonCompletionType;
  completionThreshold: number;
  allowRestart: boolean;
  displaySettings: LessonDisplaySettings;
  /** User progress status based on `ModuleCertificate`'s `completed` and `expires`.
   */
  moduleProgressStatus: ProgressStatusCode;
  latestPortfolioAttempt: LessonAttempt;
  newVersionAvailable: boolean;
  timeToComplete?: number;
}
interface PathwayLessonVm {
  pathkey: string;
  pathname: string;
  cert: boolean;
  lessonkey: string;
  wizard: boolean;
  zones: ZoneVm[]; // * A pathway may be assigned to more than one distribution zone.
  title: string;
  results: LessonResultVm[]; //* Bracken 1
}

export default PathwayLessonVm;
